export const SHORT_DATE_FORMAT_WITH_HOURS = 'MMM dd, hh:mm a';
export const FULL_DATE_FORMAT = 'MMM dd, yyyy, hh:mm a';
export const CSV_EXPORT_FULL_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss ZZZZ';

export const DATE_ONLY_FORMAT = 'MMM dd, yyyy';

export const EMAIL_DATE_FORMAT = 'MM/dd/yyyy';
